import OffshoreBanner from './OffshoreBanner';
export default OffshoreBanner;